import { FC } from 'react';
import NoSessionLayout from '../components/Layouts/NoSessionLayout';

const NotFound: FC = () => {
	return (
		<NoSessionLayout>
			<h1>Página desconocida</h1>
		</NoSessionLayout>
	);
};

export default NotFound;
